import { Box } from '@mantine/core';
import type { DateValue } from '@mantine/dates';
import { Text as FoundationsText } from '@repo/foundations';
import dayjs from 'dayjs';
import { get, isNil } from 'lodash-es';
import type { ISecodaEntity } from '../../api/index.ts';

interface OptimizedDatePickerRenderProps<T> {
	record: T;
	field: string;
	label?: string;
}

/**
 * Lightweight read-only component to display dates.
 * Used when user doesn't have permission to edit.
 */
export function OptimizedDatePickerRender<T extends ISecodaEntity>({
	record,
	field,
	label,
}: OptimizedDatePickerRenderProps<T>) {
	const value = get(record, field) as DateValue;

	return (
		<>
			{!isNil(value) && (
				<FoundationsText style={{ textWrap: 'nowrap' }} size="sm">
					{dayjs(value).format('MMM D, YYYY')}
				</FoundationsText>
			)}
			{isNil(value) && (
				<Box aria-label="placeholder">
					<FoundationsText size="sm" color="text/secondary/default">
						Add {label ?? field}
					</FoundationsText>
				</Box>
			)}
		</>
	);
}
